import WalkInHero from './components/WalkInHero';
import WalkInProcess from './components/WalkInProcess';
import WalkInDetails from './components/WalkInDetails';
import WalkInFAQ from './components/WalkInFAQ';
import WalkInCTA from './components/WalkInCTA';

export default function WalkInPage() {
  return (
    <main>
      <WalkInHero />
      <WalkInProcess />
      <WalkInDetails />
      <WalkInFAQ />
      <WalkInCTA />
    </main>
  );
}
